/* eslint-disable */
<template>
    <div id="app" class="raiz">
        <div class="vis-header">
            <h4>There are still 42.5 million undernourished people in Latin America and the Caribbean</h4>
            <p>And that despite the region produces and exports to the world large quantities of food.</p>
        </div>

        <div class="field is-horizontal vis-controls">
            <div class="field-label is-normal">
                <label class="label">Country:</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select">
                            <select id="country-select"
                                    class="is-hovered"
                                    @change="drawVis"
                                    v-model="ui.selectedCountry">
                                <option v-for="country in ui.selectCountryOptions"
                                        v-bind:value="country">
                                    {{country}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal vis-controls">
            <div class="field-label is-normal">
                <label class="label">Indicator:</label>
            </div>
            <div class="field-body">
                <div class="control">
                    <button class="button is-light"
                            @click="uiButtonIndicator('NUM')"
                            v-bind:class="{ 'is-dark': ui.selectedIndicator === 'NUM' }">
                        Number of people
                    </button>
                    <button class="button is-light"
                            @click="uiButtonIndicator('PER')"
                            v-bind:class="{ 'is-dark': ui.selectedIndicator === 'PER' }">
                        % population
                    </button>
                </div>
            </div>
        </div>

        <div class="vis-body">
            <div class="vis-content" >
                <div v-bind:class="{ 'hidden': ui.selectedCountry !== 'Todos los países' }">
                    <highcharts :constructor-type="'stockChart'" :options="visA.chartOptions"></highcharts>
                </div>
                <div v-bind:class="{ 'hidden': ui.selectedCountry === 'Todos los países' }">
                    <vue-plotly :data="visB.data" :layout="visB.layout" :options="visB.options"></vue-plotly>
                </div>
            </div>
        </div>

        <div class="vis-footer">
            <p>
                <small>Source: FAO. <a href="http://bit.ly/bid-dataset-malnutricion" target="_blank">Download the data here</a></small>
            </p>
        </div>
    </div>
</template>

<script>
    import d3 from "./d3.import.js";
    import Highcharts from 'highcharts'
    import Streamgraph from 'highcharts/modules/streamgraph'
    import SeriesLabel from 'highcharts/modules/series-label'

    import {Chart} from 'highcharts-vue'
    import plotly from "./plotly.import";
    import plotES from "plotly.js/lib/locales/es";
    import VuePlotly from "@statnett/vue-plotly";

    plotly.register(plotES);
    plotly.setPlotConfig({ locale: "es" });

    export default {
        name: "app",
        components: {
            VuePlotly,
            Chart
        },
        data: () => {
            return {
                ui: {
                    selectCountryOptions: [],
                    selectedCountry: 'Argentina',
                    allCountriesLabel: 'Todos los países',
                    selectedIndicator: "NUM"
                },
                visA: {
                    chartOptions: {
                        series: [{
                            data: []
                        }]
                    }
                },
                visB: {
                    data: [],
                    layout: {
                        showlegend: false,
                        margin: {
                            l: 50,
                            r: 20,
                            b: 30,
                            t: 30,
                            pad: 0
                        },
                        font: {
                            family: "Open Sans, Helvetica, Arial, sans-serif",
                            size: 12,
                            color: "#3C3B3B"
                        },
                        colorway: ["#E6A644", "#47A6BD"]
                    },
                    options: {responsive: true}
                },
                data: {
                    malnourishment: undefined
                }
            };
        },
        mounted: function () {
            this.loadData();
        },
        methods: {
            loadData: function () {
                let vm = this;
                d3.csv(process.env.BASE_URL + "data/malnutricion_cw.csv").then(
                    function (data) {
                        vm.data.malnourishment = data;
                        vm.uiLoadSelectCountries(data);
                        vm.drawVis();
                    }
                );
            },
            uiLoadSelectCountries: function (data) {
                let vm = this;
                // vm.ui.selectedCountry = vm.ui.allCountriesLabel;
                // vm.ui.selectCountryOptions.push(vm.ui.allCountriesLabel);
                vm.ui.selectCountryOptions.push(...new Set(data.map(x => x.COUNTRY_EN)));
            },
            uiButtonIndicator: function(option) {
                let vm = this;
                vm.ui.selectedIndicator = option;
                vm.drawVis();
            },
            drawVis: function () {
                let vm = this;
                if(vm.ui.selectedCountry === vm.ui.allCountriesLabel) {
                    vm.drawA();
                } else {
                    vm.drawB();
                }
            },
            drawA: function() {

                // ToDo

            },
            drawB: function() {
                let vm = this;
                let indicator = vm.ui.selectedIndicator === "PER" ? "%" : "millions";

                let countryData = vm.data.malnourishment.filter(
                    x => x.COUNTRY_EN === vm.ui.selectedCountry && x.UNIT === indicator
                );

                let valuesBySector = d3
                    .nest()
                    .key(function(d) {
                        return d.PAIS_ES;
                    })
                    .entries(countryData)
                    .sort(function(a, b) {
                        return a.YEAR - b.YEAR;
                    });

                if(vm.ui.selectedIndicator === "PER") {

                    let values = valuesBySector.map(function(d) {
                        let x = [];
                        let y = [];
                        let y2 = [];

                        d.values.forEach(function(d) {
                            x.push(d.YEAR);
                            y.push(Number.parseFloat(d.VALUE));
                            y2.push(100.0 - Number.parseFloat(d.VALUE));
                        });

                        let tracs = [
                            {
                                type: "bar",
                                x: x,
                                y: y,
                                name: "% undernourished"
                            },
                            {
                                type: "bar",
                                x: x,
                                y: y2,
                                name: "% normal"
                            }
                        ];
                        console.log(tracs);
                        return tracs;

                    });

                    vm.visB.data = values[0];

                    vm.visB.layout = {barmode: 'stack'};

                    vm.visB.layout.yaxis = {
                        title: "",
                        range: [0, 100],
                        hoverformat: ".2f"
                    };
                } else {
                    vm.visB.data = valuesBySector.map(function(d) {
                        let x = [];
                        let y = [];

                        d.values.forEach(function(d) {
                            x.push(d.YEAR);
                            y.push(Number.parseFloat(d.VALUE));
                        });

                        return {
                            type: "scatter",
                            x: x,
                            y: y,
                            name: d.key,
                            line: {
                                shape: "spline",
                                width: 3
                            }
                        };
                    });


                    let maxValue = d3.max(countryData.map(x => +x.VALUE));

                    vm.visB.layout = {
                        showlegend: false,
                        margin: {
                            l: 50,
                            r: 20,
                            b: 30,
                            t: 30,
                            pad: 0
                        },
                        font: {
                            family: "Open Sans, Helvetica, Arial, sans-serif",
                            size: 12,
                            color: "#3C3B3B"
                        },
                        colorway: ["#E6A644", "#47A6BD"]
                    };

                    vm.visB.layout.yaxis = {
                        title: "",
                        range: [0, 2],
                        hoverformat: ".2f"
                    };

                    vm.visB.layout.yaxis.range = [0, maxValue * 1.02];
                    vm.visB.layout.yaxis.title = "Millions of people"
                }


            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "~bulma/bulma";
    @import "assets/typography";

    #app {
        font-family: "Open Sans", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #222;
        max-width: 720px;
        margin: 0 auto;
        padding: 15px 5px;
        border-top: 2px solid #3c3b3b;
        background-color: #ffffff;

        @include mobile {
            padding: 15px 10px;
        }
    }

    div.vis-header {
        h3,
        h4 {
            margin-top: 0;
        }
    }

    div.vis-controls {
        margin-top: 20px;
    }

    div.vis-body {
        min-height: 100px;
        margin-top: 0;
    }

    div.vis-footer {
        margin-top: 10px;
        padding: 5px 0;
        border-top: 1px solid grey;

        p {
            margin-bottom: 0;
        }
    }
</style>
<style lang="scss">
    .modebar {
        display: none !important;
    }
    button {
        margin-right: 10px;
    }
    .hidden {
        display: none;
    }
</style>
